
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!conversations.message_item";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'conversations/messageItem';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  
  return "\n<div class=\"message-info\">\n  <div class=\"user-info\">\n";
  }

function program3(depth0,data) {
  
  
  return "\n<div class=\"row-fluid message-info\">\n  <div class=\"span8 user-info\">\n";
  }

function program5(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " <i>("
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.pronouns)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ")</i> ";
  return buffer;
  }

function program7(depth0,data) {
  
  
  return ",";
  }

function program9(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n              <span>";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1);
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.pronouns), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</span>\n            ";
  return buffer;
  }
function program10(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += " <i>(";
  if (helper = helpers.pronouns) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.pronouns); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + ")</i>";
  return buffer;
  }

function program12(depth0,data) {
  
  
  return "\n          <a href=\"#\" class=\"message-participants-toggle\"></a>\n        ";
  }

function program14(depth0,data) {
  
  
  return "\n  <div class=\"message-metadata clearfix\">\n    <div class=\"date\">\n  ";
  }

function program16(depth0,data) {
  
  
  return "\n  <div class=\"span4 message-metadata\">\n    <div class=\"date pull-right\">\n  ";
  }

function program18(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.responsive_awareness), {hash:{},inverse:self.program(21, program21, data),fn:self.program(19, program19, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.cannot_reply), {hash:{},inverse:self.noop,fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n      <li>\n        <div class=\"inline-block\">\n          <a href=\"#\"\n             data-kyle-menu-options='{\"appendMenuTo\": \"body\"}'\n             role=\"button\"\n             class=\"al-trigger Button Button--icon-action\"\n             title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("conversations.message_item")
  },data:data},helper ? helper.call(depth0, "more_options", "More options", options) : helperMissing.call(depth0, "t", "more_options", "More options", options)))
    + "\"\n             data-tooltip>\n            <i class=\"icon-settings\"></i>\n            <i class=\"icon-mini-arrow-down\"></i>\n            <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'text': ((depth0 && depth0.text)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "message_actions_for_text_27eead86", "Message actions for %{text}", options) : helperMissing.call(depth0, "t", "message_actions_for_text_27eead86", "Message actions for %{text}", options)))
    + "</span>\n          </a>\n          <ul class=\"al-options\">\n            ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.cannot_reply), {hash:{},inverse:self.noop,fn:self.program(25, program25, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            <li>\n              <a href=\"#\" class=\"forward-btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("conversations.message_item")
  },data:data},helper ? helper.call(depth0, "forward", "Forward", options) : helperMissing.call(depth0, "t", "forward", "Forward", options)))
    + "</a>\n            </li>\n            <li>\n              <a href=\"#\" class=\"delete-btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("conversations.message_item")
  },data:data},helper ? helper.call(depth0, "delete", "Delete", options) : helperMissing.call(depth0, "t", "delete", "Delete", options)))
    + "</a>\n            </li>\n          </ul>\n        </div>\n      </li>\n    </ul>\n    ";
  return buffer;
  }
function program19(depth0,data) {
  
  
  return "\n    <ul class=\"actions unstyled\">\n    ";
  }

function program21(depth0,data) {
  
  
  return "\n    <ul class=\"actions pull-right unstyled\">\n    ";
  }

function program23(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <li>\n        <a href=\"#\"\n           class=\"icon-reply-2 reply-btn Button Button--icon-action\"\n           title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "reply_389d6fb9", "Reply", options) : helperMissing.call(depth0, "t", "reply_389d6fb9", "Reply", options)))
    + "\"\n           data-tooltip>\n          <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'text': ((depth0 && depth0.text)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "reply_to_conversation_text_cd45c48f", "Reply to conversation %{text}", options) : helperMissing.call(depth0, "t", "reply_to_conversation_text_cd45c48f", "Reply to conversation %{text}", options)))
    + "</span>\n        </a>\n      </li>\n      ";
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n              <li>\n                <a href=\"#\" class=\"reply-all-btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("conversations.message_item")
  },data:data},helper ? helper.call(depth0, "reply_all", "Reply all", options) : helperMissing.call(depth0, "t", "reply_all", "Reply all", options)))
    + "</a>\n              </li>\n            ";
  return buffer;
  }

function program27(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n<ul class=\"message-attachments\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.media_comment), {hash:{},inverse:self.noop,fn:self.program(28, program28, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.attachments), {hash:{},inverse:self.noop,fn:self.program(30, program30, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</ul>\n";
  return buffer;
  }
function program28(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <li><a class=\"instructure_inline_media_comment\" data-media_comment_id=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.media_comment)),stack1 == null || stack1 === false ? stack1 : stack1.media_id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" href=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.media_comment)),stack1 == null || stack1 === false ? stack1 : stack1.url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n      <i class=\"icon-media\"></i> "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.media_comment)),stack1 == null || stack1 === false ? stack1 : stack1.display_name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n    </a></li>\n  ";
  return buffer;
  }

function program30(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <li>\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.locked_for_user), {hash:{},inverse:self.program(33, program33, data),fn:self.program(31, program31, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </li>\n  ";
  return buffer;
  }
function program31(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <i class=\"icon-paperclip\"></i>\n        ";
  if (helper = helpers.display_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.display_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n        <br><em>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "this_attachment_has_been_unpublished_by_the_author_37bff9c3", "This attachment has been unpublished by the author.", options) : helperMissing.call(depth0, "t", "this_attachment_has_been_unpublished_by_the_author_37bff9c3", "This attachment has been unpublished by the author.", options)))
    + "</em>\n      ";
  return buffer;
  }

function program33(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n          <i class=\"icon-paperclip\"></i>\n          ";
  if (helper = helpers.display_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.display_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n        </a>\n      ";
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.responsive_awareness), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    <div id=";
  if (helper = helpers.avatarContainerId) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.avatarContainerId); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " class=\"fs-exclude avatar\"></div>\n    <div class=\"message-author-and-participants\">\n      <b class=\"username\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1));
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.pronouns), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</b>";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.participants)),stack1 == null || stack1 === false ? stack1 : stack1.length), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n      <span class=\"message-participants-wrapper\">\n        <span class=\"message-participants\" aria-live=\"polite\"></span>\n        <div class=\"hidden\">\n          <span class=\"summarized-message-participants\">\n            ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.summarizedParticipantNames), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "...\n          </span>\n          <span class=\"full-message-participants\">\n            ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.participantNames), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </span>\n        </div>\n\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.summarizedParticipantNames), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </span>\n\n      <span class=\"context\">";
  if (helper = helpers.context_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.context_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n\n    </div>\n  </div>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.responsive_awareness), {hash:{},inverse:self.program(16, program16, data),fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n			"
    + escapeExpression((helper = helpers.tEventToString || (depth0 && depth0.tEventToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.created_at), "long", "tiny", options) : helperMissing.call(depth0, "tEventToString", (depth0 && depth0.created_at), "long", "tiny", options)))
    + "\n		</div>\n\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.for_submission), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	</div>\n</div>\n\n<p>";
  if (helper = helpers.bodyHTML) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.bodyHTML); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</p>\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.has_attachments), {hash:{},inverse:self.noop,fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  